import { TAG_ATTRIBUTE_TYPES, ASSOCIATED_VALUE } from "src/consts/tags";
import getInputLabel from "src/util/getInputLabel";
import TagSearchSelect from "src/components/TagSearchDropdown";
import TagAttributeDateInput from "./TagAttributeDateInput";
import TagAttributeGroupSelect from "./TagAttributeGroupSelect";
import TagAttributePersonSelect from "./TagAttributePersonSelect";
import { getLabel } from "./TagAttributeModal.logic";

const renderEditorPlainInput = ({
  id,
  type,
  name,
  disabled,
  InputComponent,
  others,
}) => {
  if (
    type === TAG_ATTRIBUTE_TYPES.TEXT ||
    type === TAG_ATTRIBUTE_TYPES.ENTITY_ID
  ) {
    return (
      <InputComponent
        id={id}
        name={name}
        type="text"
        disabled={disabled}
        {...others}
        label={getInputLabel(others.label, others.invalid)}
      />
    );
  }
  if (type === TAG_ATTRIBUTE_TYPES.NUMBER) {
    return (
      <InputComponent
        id={id}
        name={name}
        type="number"
        disabled={disabled}
        {...others}
        label={getInputLabel(others.label, others.invalid)}
      />
    );
  }
  if (type === TAG_ATTRIBUTE_TYPES.INTEGER) {
    return (
      <InputComponent
        id={id}
        name={name}
        type="number"
        disabled={disabled}
        numberProps={{
          decimalScale: 0,
          onKeyDown: (evt) => {
            if (evt.key === ".") {
              evt.preventDefault();
            }
          },
        }}
        {...others}
        label={getInputLabel(others.label, others.invalid)}
      />
    );
  }
  if (type === TAG_ATTRIBUTE_TYPES.LINK) {
    return (
      <InputComponent
        id={id}
        name={name}
        type="url"
        disabled={disabled}
        {...others}
        label={getInputLabel(others.label, others.invalid)}
      />
    );
  }
  return null;
};

const renderEditorRelationInput = ({
  id,
  type,
  name,
  disabled,
  onSelectAttrValue,
  onDateChange,
  featureFlags,
  InputComponent,
  others,
}) => {
  if (type === TAG_ATTRIBUTE_TYPES.DATE) {
    if (name === ASSOCIATED_VALUE || disabled) {
      return (
        <InputComponent
          id={id}
          name={name}
          disabled={disabled}
          type="text"
          {...others}
        />
      );
    }
    return (
      <TagAttributeDateInput
        id={id}
        type={type}
        name={name}
        onDateChange={onDateChange}
        {...others}
      />
    );
  }
  if (type === TAG_ATTRIBUTE_TYPES.GROUPTYPE) {
    return (
      <TagAttributeGroupSelect
        id={id}
        onSelectGroup={onSelectAttrValue}
        disabled={disabled}
        resolvedTeamTypeIds={others.resolvedTeamTypeIds}
        {...others}
      />
    );
  }
  if (type === TAG_ATTRIBUTE_TYPES.PERSON) {
    return (
      <TagAttributePersonSelect
        id={id}
        onSelectPerson={onSelectAttrValue}
        disabled={disabled}
        featureFlags={featureFlags}
        {...others}
      />
    );
  }
  if (type === TAG_ATTRIBUTE_TYPES.TAGTYPE) {
    return (
      <TagSearchSelect
        label={others.label}
        tagTypes={[others.associatedValue]}
        value={others.value}
        onSelectTag={onSelectAttrValue}
        disabled={others.disabled}
        invalid={others.invalid}
        mandatory={others.mandatory}
        focus={others.focus}
      />
    );
  }
  if (type === TAG_ATTRIBUTE_TYPES.PARENT_TAG) {
    return (
      <TagSearchSelect
        label={getLabel("Parent tag", disabled)}
        tagTypes={[others.associatedValue]}
        value={others.value}
        onSelectTag={onSelectAttrValue}
        disabled={disabled}
        invalid={others.invalid}
        mandatory={others.mandatory}
        focus={others.focus}
      />
    );
  }
  return null;
};

export const renderEditorAttributeInput = (props) => {
  const {
    id,
    type,
    name,
    onSelectAttrValue,
    disabled = false,
    onDateChange,
    featureFlags,
    InputComponent,
    ...others
  } = props;
  const plain = renderEditorPlainInput({
    id,
    type,
    name,
    disabled,
    InputComponent,
    others,
  });
  return (
    plain ??
    renderEditorRelationInput({
      id,
      type,
      name,
      disabled,
      onSelectAttrValue,
      onDateChange,
      featureFlags,
      InputComponent,
      others,
    })
  );
};
